import store from "../../store";
import { ensureCapabilities } from "../../utils/accessControl.mjs";
import { SKILL_MATRIX_SECTIONS, skillMatrixRoute } from "./skillMatrixSections.mjs";

const HrDashboard = () => import("./HrDashboard");
const HrEmployees = () => import("./HrEmployees");
const HrDipendente = () => import(/* webpackChunkName: "hr-employee-detail" */ "./HrDipendente");
const HrRecruiting = () => import("./HrRecruiting");
const HrAdministration = () => import("./HrAdministration");
const HrCommunications = () => import("./HrCommunications");
const HrSkills = () => import("./HrSkills");
const HrRoles = () => import("./HrRoles");
const HrRoleDetail = () => import("./HrRoleDetail");
const HrTaskDetail = () => import("./HrTaskDetail");
const HrDevelopment = () => import("./HrDevelopment");
const HrAlignmentEditor = () => import("./HrAlignmentEditor");
const HrWorkCenters = () => import("./HrWorkCenters");
const HrStandardOperation = () => import("./HrStandardOperation");

// La guardia client aiuta l'UX; el backend ricontrolla sempre i permessi veri.
const ifHrAdmin = async (to, from, next) => {
    if (!store.getters.isLoggedIn) return next("/login");
    try {
        await ensureCapabilities(store, window.work_api);
        if (!store.getters.hasCapability("hr.area")) return next("/");
    } catch (error) {
        if (!store.getters.hasGroups(["Amministrazione"])) return next("/");
    }
    return next();
};

export default [
    { path: "/hr/comunicazioni/", name: "hr-comunicazioni", meta: { menu: "hr", title: "HR Comunicazioni" }, component: HrCommunications, beforeEnter: ifHrAdmin },
    { path: "/hr/centri-lavoro/operazioni-standard/:numero(\\d+)/", name: "hr-operazione-dettaglio", meta: { menu: "hr", title: "HR Dettaglio operazione" }, component: HrStandardOperation, beforeEnter: ifHrAdmin },
    { path: "/hr/", name: "hr-dashboard", meta: { menu: "hr", title: "HR Dashboard" }, component: HrDashboard, beforeEnter: ifHrAdmin },
    { path: "/hr/dipendenti/", name: "hr-dipendenti", meta: { menu: "hr", title: "HR Dipendenti" }, component: HrEmployees, beforeEnter: ifHrAdmin },
    { path: "/hr/dipendenti/:id/", name: "hr-dipendente", meta: { menu: "hr", title: "Scheda dipendente" }, component: HrDipendente, beforeEnter: ifHrAdmin },
    { path: "/hr/recruiting/", name: "hr-recruiting", meta: { menu: "hr", title: "HR Recruiting" }, component: HrRecruiting, beforeEnter: ifHrAdmin },
    { path: "/hr/amministrazione/", name: "hr-amministrazione", meta: { menu: "hr", title: "HR Amministrazione" }, component: HrAdministration, beforeEnter: ifHrAdmin },
    { path: "/hr/competenze/", name: "hr-competenze", meta: { menu: "hr", title: "HR Competenze" }, component: HrSkills, beforeEnter: ifHrAdmin },
    { path: "/hr/mansioni/", name: "hr-mansioni", meta: { menu: "hr", title: "HR Mansioni" }, component: HrRoles, beforeEnter: ifHrAdmin },
    { path: "/hr/mansioni/:id/", name: "hr-mansione-dettaglio", meta: { menu: "hr", title: "Dettaglio mansione" }, component: HrRoleDetail, beforeEnter: ifHrAdmin },
    { path: "/hr/attivita/:id/", name: "hr-attivita-dettaglio", meta: { menu: "hr", title: "Dettaglio attività" }, component: HrTaskDetail, beforeEnter: ifHrAdmin },
    { path: "/hr/ruoli/", redirect: (to) => ({ name: "hr-mansioni", query: to.query }) },
    { path: "/hr/colloqui/", name: "hr-colloqui", meta: { menu: "hr", title: "HR Colloqui" }, component: HrDevelopment, beforeEnter: ifHrAdmin },
    { path: "/hr/colloqui/nuovo/", name: "hr-colloquio-nuovo", meta: { menu: "hr", title: "Nuovo colloquio" }, component: HrAlignmentEditor, beforeEnter: ifHrAdmin },
    { path: "/hr/colloqui/:id/", name: "hr-colloquio", meta: { menu: "hr", title: "Colloquio" }, component: HrAlignmentEditor, beforeEnter: ifHrAdmin },
    { path: "/hr/sviluppo/", redirect: (to) => ({ name: "hr-colloqui", query: to.query }) },
    { path: "/hr/sviluppo/colloqui/nuovo/", redirect: (to) => ({ name: "hr-colloquio-nuovo", query: to.query }) },
    { path: "/hr/sviluppo/colloqui/:id/", redirect: (to) => ({ name: "hr-colloquio", params: to.params, query: to.query }) },
    { path: "/hr/centri-lavoro/", name: "hr-centri-lavoro", redirect: (to) => ({ ...skillMatrixRoute(1, to.query), hash: to.hash }) },
    ...SKILL_MATRIX_SECTIONS.map((section, index) => ({
        path: `/hr/centri-lavoro/${section.slug}/`, name: skillMatrixRoute(index).name,
        meta: { menu: "hr", title: `HR Skill matrix · ${section.title}`, skillMatrixTab: index },
        component: HrWorkCenters, beforeEnter: ifHrAdmin,
    })),
];
